import { GiftSubscription, UserExtended } from "../context/authContext/reducer";

export const userTypeOptions = [
  { name: "user_type", value: "Enthusiast", label: "Enthusiast" },
  { name: "user_type", value: "Retailer", label: "Retailer" },
  { name: "user_type", value: "Restaurant", label: "Restaurant" },
  { name: "user_type", value: "Winemaker", label: "Winemaker" },
  { name: "user_type", value: "Distributer", label: "Distributer" },
  { name: "user_type", value: "Broker", label: "Broker" },
  { name: "user_type", value: "Importer", label: "Importer" },
  { name: "user_type", value: "Auction House", label: "Auction House" },
  { name: "user_type", value: "Media", label: "Media" },
];

export const userAgeOptions = [
  { name: "age", value: "<25", label: "<25" },
  { name: "age", value: "25-34", label: "25-34" },
  { name: "age", value: "35-44", label: "35-44" },
  { name: "age", value: "45-54", label: "45-54" },
  { name: "age", value: "55-64", label: "55-64" },
  { name: "age", value: "65+", label: "65+" },
];

export const userInitialState: UserExtended = {
  email: "",
  password: "",
  password_confirmation: "",
  first_name: "",
  last_name: "",
  user_type: "",
  address: "",
  address2: "",
  city: "",
  state: "",
  business_name: "",
  business_url: "",
  zip: "",
  country: "",
  subscription_name: "",
  admin: false,
  gender: "",
  age: "",
  regular_updates: true,
  share_information: true,
};

export const giftSubscriptionInitialState: GiftSubscription = {
  recipient: [
    {
      recipientEmail: "",
      recipientFirstName: "",
      recipientLastName: "",
    },
  ],
  customerEmail: "",
  customerFirstName: "",
  customerLastName: "",
  comments: "",
  personalMessage: "",
};

export interface PlanDetails {
  id: number;
  name: string;
  stripe_id: string;
  price: number;
  features: Array<string>;
  onlyDetails: boolean;
  isRedirecting: boolean;
}

export const tradePlans = {
  basicPro: {
    id: 56,
    name: "Basic Pro",
    stripe_id: "basic_pro_500",
    price: 500,
    features: [
      "Access to Vinous website and apps",
      "Use up to 500 reviews, maximum 50/article, in-stock wines only (wineries exempt)",
      "Single user per login",
      "Wineries may: submit tasting requests; access Vinous medals artwork",
    ],
    onlyDetails: false,
    isRedirecting: false,
  },
  enterprise: {
    id: 57,
    name: "Enterprise",
    stripe_id: "enterprise_2000",
    price: 2000,
    features: [
      "Unlimited number of users",
      "Use up to 1,500 reviews",
      "Third parties (e.g. importers) may:",
      "Submit tasting requests",
      "Provide contact information to be associated with producers",
      "Access Vinous medals artwork",
    ],
    onlyDetails: false,
    isRedirecting: false,
  },
  enterprise_max: {
    id: 58,
    name: "Vinous Enterprise +/Max",
    stripe_id: "",
    price: 0,
    features: [
      "Additional Options Include:",
      "Reviews via spreadsheet, matched to Liv-ex LWINs",
      "Vintage reports for key regions",
      "48 Hour Preview of all reviews and scores",
    ],
    onlyDetails: true,
    isRedirecting: false,
  },
};

export const backText = "< Back to plans";

export enum planOptions {
  consumer = 'consumer',
  trade = 'trade'
}

export const bottomText = "Your payment method will automatically be charged the applicable rate in advance of your subscription period. You will receive a notification by email ahead of your subscription renewal. Your subscription will continue until you cancel. Cancellation takes effect at the end of your current billing period. Taxes may apply. Offer terms are subject to change.";
